<template>
  <div class="ui-alerts-wrapper">
    <transition v-for="alert in alerts" :key="alert.id" appear name="fade">
      <AlertTooltip :alert="alert" />
    </transition>
  </div>
</template>

<script>
  import AlertTooltip from '@/components/ui/alert-tooltip/AlertTooltip';
  import { mapState } from 'vuex';

  export default {
    name: 'AlertTooltipsContainer',
    components: {
      AlertTooltip,
    },
    computed: {
      ...mapState('alert', ['alerts']),
    },
  };
</script>
